<div class="general_alertContainer">
    <div *ngFor="let alert of list">
        <div class="body">
            <div class="icon">
                <img src={{alert.image}}>
            </div>
            <div class="information_message" [innerHTML]="alert.text | translate" dataqsi="informationMessage"></div>
        </div>
    </div>
</div>
